import type { Action } from 'redux';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { DataAction } from '../../../types/dataAction.type';
import type { Dispatch } from '../../../types/redux.types';
import type { Settings, User } from '../types';

const UpdateUserSettings = new ReduxAsyncAction<'UPDATE_USER_SETTINGS', Settings, User>('UPDATE_USER_SETTINGS');

UpdateUserSettings.registerRequest(function (body) {
  return dash_api.patch(`/v1/dashboard-user`, body).then((res) => res.data);
});

export const UPDATE_USER_SETTINGS = UpdateUserSettings.actionNamespaceConstants;

export const updateUserSettings = (settings: Settings) => async (dispatch: Dispatch) => {
  try {
    await dispatch(UpdateUserSettings.request(settings));
    NotificationActions.showNotification('Settings updated', 'success');
    // biome-ignore lint/correctness/noUnusedVariables: ignored using `--suppress`
  } catch (err) {
    NotificationActions.showNotification('Could no update user settings', 'error');
  }
};

export type UpdateUserSettingsRequestAction = Action<typeof UPDATE_USER_SETTINGS.request>;
export type UpdateUserSettingsResponseAction = DataAction<typeof UPDATE_USER_SETTINGS.response, User>;
